import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { EventDto } from "../../../models/event/dto/event.dto";

export const GET_EVENT_QUERY_KEY = (id: number) => ['event', id];
export const useGetEvent = (id: number) => {
    const apiClient = useApiClient();

    return useQuery<EventDto>({
        queryKey: GET_EVENT_QUERY_KEY(id),
        queryFn: async () => {
            return apiClient.fetchApi<EventDto, {}>({
                method: 'GET',
                endpoint: `events/${id}`
            });
        },
        enabled: !!id,
    });
};